import { LocalStorageKeys } from 'shared/consts'
import { authRequest } from 'shared/lib'
import { decodeUserToken, getInitialState, loginOut } from 'shared/store/useLogin'
import { StateType } from 'shared/store/useLogin/types'
import { QueryClient } from 'react-query'
import isAxiosError from './isAxiosError'

export async function getRefreshToken(queryClient: QueryClient) {
   try {
      const refreshToken = localStorage.getItem(LocalStorageKeys.REFRESH_TOKEN) || ''
      const params = new URLSearchParams()
      params.append('refresh_token', refreshToken)

      const res = await authRequest.post<{ accessToken: string }>('token/refresh', params)
      const token = res.data.accessToken
      const { expirationDate, roles, uuid, frontendVersionTimestamp } = decodeUserToken(token)

      localStorage.setItem(LocalStorageKeys.ACCESS_TOKEN, token)
      localStorage.setItem(LocalStorageKeys.EXPIRES_IN, `${expirationDate}`)
      const initialUser = queryClient.getQueryData<StateType>('user') || getInitialState()
      queryClient.setQueryData('user', {
         ...initialUser,
         loginStatus: 'logged',
         accessToken: res.data.accessToken,
         frontendVersionTimestamp,
         roles,
         uuid,
      })
   } catch (error: any) {
      if (error.response?.status === 423) {
         loginOut('/session-end').then(() => {
            if (isAxiosError<ErrorType>(error)) {
               switch (error.response?.data.errors[0].code) {
                  case 'errors.authentication.refresh-token-expired':
                     window.location.href = '/session-end?reason=expired'
                     break
                  case 'errors.authentication.refresh-token-invalidated':
                     window.location.href = '/session-end?reason=loggedOut'
                     break
                  case 'errors.authentication.session-expired':
                     window.location.href = '/session-end?reason=subscription'
                     break
                  default:
                     window.location.href = '/session-end?reason=expired'
               }
            }
         })
      }
   }
}
